import { round } from "lodash";

import { Nodes } from "@/pages/scenario-builder/utils";

import { ChannelTotalROIMap } from "../types";

interface NodeData {
  nodeUuid: string;
  aggregated: ChannelTotalROIMap;
  split: ChannelTotalROIMap;
  totals: {
    totalSpend: number;
    totalRevenue: number;
  };
}

export interface CombinedNodeData {
  aggregated: Record<
    string,
    ChannelTotalROIMap[string] & {
      nodeUuid: string;
      brand: string;
      category: string;
      product: string;
    }
  >;
  split: Record<
    string,
    ChannelTotalROIMap[string] & {
      nodeUuid: string;
      brand: string;
      category: string;
      product: string;
    }
  >;
  totals: {
    totalSpend: number;
    totalRevenue: number;
  };
}
// TODO Add the node name here
export const combineNodeData = (
  roiData: NodeData[] | undefined,
  nodes: Nodes | null
): CombinedNodeData | undefined => {
  if (!roiData) return undefined;

  return roiData.reduce(
    (acc, node) => {
      const currentNode = nodes?.getNode(node.nodeUuid);
      const brand = currentNode?.node.brand ?? "";
      const category = currentNode?.node.category ?? "";
      const product = currentNode?.node.product ?? "";

      // For aggregated data
      Object.entries(node.aggregated).forEach(([channel, data]) => {
        const key = `${channel}-${node.nodeUuid}`;
        acc.aggregated[key] = {
          ...data,
          nodeUuid: node.nodeUuid,
          brand,
          category,
          product,
        };
      });

      // For split data
      Object.entries(node.split).forEach(([channel, data]) => {
        const key = `${channel}-${node.nodeUuid}`;
        acc.split[key] = {
          ...data,
          nodeUuid: node.nodeUuid,
          brand,
          category,
          product,
        };
      });

      // Add to totals
      acc.totals.totalSpend = round((acc.totals.totalSpend || 0) + node.totals.totalSpend, 2);
      acc.totals.totalRevenue = round((acc.totals.totalRevenue || 0) + node.totals.totalRevenue, 2);
      return {
        ...acc,
        brand,
        category,
        product,
      };
    },
    { aggregated: {}, split: {}, totals: { totalSpend: 0, totalRevenue: 0 } } as CombinedNodeData
  );
};
